<template>
  <div class="interrupt">
    <div class="main">
      <p class="score">{{ process }}%</p>
      <p class="top-tips">{{ $t('openAccount.t000016') }}</p>
      <div class="list-box">
        <div class="list">
          <template v-for="(item, index) in listData">
            <div v-if="result.process_info && result.process_info[item.step_code] && !item.isHide" class="item" :key="index">
              <p class="title">{{ item.title }}</p>
              <a class="btn-change" @click="toPage(item)">{{ $t('openAccount.t000017') }}</a>
            </div>
          </template>
        </div>
        <div class="btn-box">
          <a class="btn" @click="reset()">{{ $t('openAccount.t000018') }}</a>
          <a class="btn" @click="next()">{{ $t('openAccount.t000019') }}</a>
        </div>
<!--        <a class="btn-institution" @click="insOpen()">{{ $t('openAccount.t000020') }}</a>-->
      </div>
    </div>
  </div>
</template>

<script>
import { getBrowser } from "@/utils/browser";
import { resolveCustomerConfirmationPath } from "../../utils/resolveCustomerConfirmationPath";

export default {
  props: {
    result: {
      type: Object,
      default: function(){
        return {

        }
      }
    }
  },
  computed: {
    process(){
      // 最后一个可以修改的 进度 就是当前进度
      let p = 0;
      if(this.result.process_info){
        const last = this.listData.find(item => this.result.process_info[item.step_code]);
        if(last){
          p = last.process;
        }
      }
      return p;
    },
    listData(){
      let list = [
        {
          path: '/open-account/customerConfirmation',
          title: this.$t("customerConfirmation.c000004"),
          step_code: '15',
          step_order: '',
          process: '99'
        },
        {
          path: '/open-account/mainlandInvestorDeclaration',
          title: this.$t("mainlandInvestorDeclaration.navTitle"),
          step_code: '13-3',
          step_order: '13',
          process: '96'
        },
        {
          path: '/open-account/face-recognition',
          title: this.$t("openAccount.t000131"),
          step_code: '13-2',
          step_order: '',
          process: '95'
        },
        {
          path: '/open-account/agreementDeclaration',
          title: this.$t("agreementDeclaration.a000007"),
          step_code: '14',
          step_order: '',
          process: '91'
        },
        {
          path: '/open-account/riskDisclosure',
          title: this.$t('open_account.risk_disclosure.nav_title'),
          step_code: '13',
          step_order: '',
          process: '87'
        },
        {
          path: '/open-account/serverOpening',
          title: this.$t("open_account.service_opening.nav_title"),
          step_code: '12',
          step_order: '',
          process: '82'
        },
        {
          path: '/open-account/customerState',
          title: this.$t('open_account.customer_state.nav_title'),
          step_code: '11',
          step_order: '',
          process: '76'
        },
        {
          path: '/open-account/w8benPage',
          title: 'W-8BEN',
          step_code: '10',
          step_order: '',
          process: '70'
        },
        {
          path: '/open-account/taxInformation',
          title: this.$t("taxInformation.title"),
          step_code: '9',
          step_order: '',
          process: '64'
        },
        {
          path: '/open-account/riskQuestionnaire',
          title: this.$t('assessment.question.pageTitle'),
          step_code: '8-1',
          step_order: '8',
          process: '46'
        },
        {
          path: '/open-account/suitabilitySurvey',
          title: this.$t("suitabilitySurvey.pageTitle"),
          step_code: '7',
          step_order: '',
          process: '40'
        },
        {
          path: '/open-account/personalInformation',
          title: this.$t('personalInformation.nav_title'),
          step_code: '6',
          step_order: '',
          process: '34'
        },
        {
          path: '/open-account/address-prove',
          title: this.$t('openAccount.t000008'),
          step_code: '4',
          step_order: '',
          process: '28'
        },
        {
          path: '/open-account/id-card-upload',
          title: this.$t('openAccount.t000130'),
          step_code: '3-2',
          step_order: '',
          process: '22',
          isHide: true
        },
        {
          path: '/open-account/id-card-upload',
          title: this.$t('openAccount.t000130'),
          step_code: '3-1',
          step_order: '',
          process: '17'
        },
        {
          path: '/open-account/openReference',
          title: this.$t('openReference.nav_title'),
          step_code: '2-1',
          step_order: '',
          process: '6'
        },
        {
          path: '/open-account/chooseIdentity',
          title: this.$t('ChooseIdentity.nav_title'),
          step_code: '2-2',
          step_order: '',
          process: '11'
        },
      ];
      const { process_id } = this.result.process_info['1'];
      if(process_id == 2){
        list = list.filter(item => item.step_code != '2-2');
      }
      return list;
    }
  },
  data(){
    return {
    }
  },
  methods: {
    getBrowser,
    async toPage(e){
      let { path } = e;
      if (path === "/open-account/customerConfirmation") {
        path = await resolveCustomerConfirmationPath(this.$apis);
      }
      this.$router.push({
        path
      });
    },
    reset(){
      this.$apis.supplementClear().then(res => {
        this.$emit('reload');
      })
    },
    /** 非内地用户不要求走 13-3 */
    async shouldIncludeMainlandStep() {
      const path = await resolveCustomerConfirmationPath(this.$apis);
      return path === "/open-account/mainlandInvestorDeclaration";
    },
    async next(){
      let list = this.listData.slice().reverse();
      const { process_id } = this.result.process_info['1'];
      // 选择地区  如何是香港的 是不需要再选的  其他的 没选的时候 是需要再选的
      if(process_id == 2){
        list = list.filter(item => item.step_code != '2-2');
      }
      const needMainland = await this.shouldIncludeMainlandStep();
      if (!needMainland) {
        list = list.filter(item => item.step_code !== '13-3');
      }
      // 选择最近一个没填写的
      let first = list.find(item => !this.result.process_info[item.step_code]);
      if(!first){
        first = list[list.length - 1]
      }
      this.toPage(first);
    },
    // 机构开户
    insOpen(){
      this.$router.push({
        path: '/open-account/openReference',
        query: {
          name: 'institutional'
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.black-theme{
  .interrupt{
    background: #1B1C24;
  }
}
.interrupt{
  background: #F9FAFC;
  min-height: 100vh;
  .main{
    padding: 32px 32px 100px;
    background: linear-gradient(
      to bottom,
      #17161C 0%,
      #17161C 20%,
      rgba(23, 22, 28, 0.6) 40%,
      rgba(23, 22, 28, 0) 60%,
      rgba(23, 22, 28, 0) 100%
    );
    .score{
      margin-top: 20px;
      font-weight: 500;
      font-size: 72px;
      line-height: 72px;
      color: #fff;
      text-align: center;
    }
    .top-tips{
      font-size: 28px;
      color: #fff;
      text-align: center;
      margin-top: 20px;
    }
    .list-box{
      margin-top: 30px;
      background: #fff;
      border-radius: 24px;
      padding: 26px 44px;
      .list{
        //min-height: 200px
      }
      .item{
        display: flex;
        justify-content: space-between;
        line-height: 60px;
        .title{
          font-weight: 500;
          color: #17161C;
        }
        .btn-change{
          color: #FD2626;
          font-weight: normal;
        }
      }
      .btn-box{
        margin-top: 32px;
        display: flex;
        .btn{
          line-height: 104px;
          flex: 1;
          text-align: center;
          color: #17161C;
          background: rgba(23,22,28,0.04);
          border-radius: 102px;
          font-size: 32px;
          font-weight: 500;
          & ~ .btn{
            margin-left: 32px;
          }
          &:last-child{
            background: #17161C;
            color: #fff;
          }
        }
      }
      .btn-institution{
        display: block;
        margin-top: 30px;
        text-align: center;
        font-size: 28px;
        color: #328CF4;
        font-weight: normal;
      }
    }
  }
}
.black-theme{
  .interrupt{
    .main{
      .list-box{
        background: #262830;
        .item{
          .title{
            color: #fff;
          }
        }
        .btn-box{
          .btn{
            color: #fff;
            background: #8E92A2;
            & ~ .btn{
              background: #377CFB;
            }
          }
        }
      }
    }
  }
}
</style>
